export default () => {
  return {
    scope: {
      onVideoEnded: '<vuiOnVideoEnded'
    },
    link: ($scope, $element) => {
      $element.on("ended", () => {
        $scope.$apply(() => {
          $scope.onVideoEnded()
        })
      });
    }
  };
}
